'use strict';

var $ = require('jquery');
window.jQuery = window.$ = $;
require('gwwp');

var svg4everybody = require('./libs/svg4everybody.js');
$(window).on('load', function () {
	svg4everybody();
});

$(function () {
	require('./components/benefit_like');
	require('./components/benefit_favourite');
	require('./components/nav.js');
	require('./components/popup.js');
	require('./components/forms.js');
	require('./components/favorite_categories.js');
	require('./components/company_admin.js');

	// If a login hash is set in the url, remove it
	if (window.location.search.substring(1).indexOf('ah=') !== -1) {
		window.history.replaceState(null, null, window.location.pathname);
	}
	if ($('.logged-in').length > 0) {
		setTimeout(function () {
			$('.moove-gdpr-infobar-allow-all').trigger('click');
		}, 5000);
	}

});

function checkSession() {
	let meta = $('meta[name="session"]');
	let user = $('meta[name="user"]');

	if (sessionStorage.logout && window.location.href.match(/\/kirjautuminen\//)) {
		sessionStorage.logout = false;
		return;
	}

	// if (meta.length === 0 && !window.location.href.match(/\/\?homescreen=1$/) && user.length === 0) {
	// 	window.location = '/?homescreen=1';
	// 	return;
	// }

	if (user.length !== 0) {
		let memberPage = $('meta[name="membership-page-url"]').attr('content') + '?homescreen=1';
		if (!sessionStorage.firstLoad) {
			sessionStorage.firstLoad = true;
			window.location = memberPage;
			return;
		}

		if (window.location.search === '?homescreen=1' && window.location.href !== memberPage) {
			window.location = memberPage;
		}
	}
}

// Chrome service worker
if ('serviceWorker' in navigator) {
	window.addEventListener('load', function () {
		navigator.serviceWorker.register('/worker.js')
			.then(function (reg) {
				console.log('ServiceWorker registration successful with scope: ', reg.scope);
			}, function (err) {
				console.log('ServiceWorker registration failed: ', err);
			});
	});

	// Homescreen app running
	if ('matchMedia' in window && window.matchMedia('(display-mode: standalone)').matches) {
		checkSession();
		$('.app-popup').remove();
		require('./components/back-forward-bar.js');
	}
}

// iStuff "app-mode"
if ('standalone' in window.navigator && window.navigator.standalone) {
	checkSession();
	$('.app-popup').remove();
	require('./components/back-forward-bar.js');

	$(function () {
		let host = window.location.hostname;

		$('a').click(function (e) {
			let href = $(this).attr('href');
			if (href.indexOf(host) !== -1 && !href.match(/\/verkkokauppa\/$/)) {
				e.preventDefault();
			}

			if ($(this).hasClass('logout')) {
				sessionStorage.logout = true;
			}
			window.location = href;
		});
	});
}

$('.samsung-link').on('click', function (e) {
	e.preventDefault();
	if ($(this).attr('disabled')) {
		return;
	}
	$(this).attr('disabled', 'disabled');
	var newWindow = window.open();
	var redirectUrl = this.href != undefined ? '&redirectUrl=' + this.href : '';
	$.ajax({
		url: window.urls.adminAjax + '?action=get_samsung_url',
		dataType: 'JSON',
		xhrFields: {
			withCredentials: true
		}
	}).then(function (res) {
		newWindow.location.replace(res.url + redirectUrl);
		$(this).removeAttr('disabled');
	});
});

